export default class CompareService {
    static canAddMore() {
        return CompareService.storedItems.length < 6;
    }

    static addItem(item) {
        const items = CompareService.storedItems;

        if (items.find(x => x.id === item.id)) return;
        items.push(item);
        CompareService.storedItems = items;
    }

    static removeItem(id) {
        CompareService.storedItems = CompareService.storedItems.filter(x => x.id !== id);
    }

    static getItems() {
        return CompareService.storedItems;
    }

    static set storedItems(value) {
        localStorage.setItem(window.compare_items_data.storageKey, JSON.stringify(value));
    }

    static get storedItems() {
        let items = null;

        try {
            items = JSON.parse(localStorage.getItem(window.compare_items_data.storageKey));
        } catch (e) {
            //Empty Block
        }

        return items || [];
    }
}